export default __webpack_public_path__ + "static/media/left.d38e9764.png";